// extracted by css-extract-rspack-plugin
export default {"size60":"60px","gapSeparator":"helper-components__gapSeparator___aPpQO","separatorWrapper":"helper-components__separatorWrapper___wmPvo"};